import JSEncrypt from 'jsencrypt/bin/jsencrypt.min';

// 加密
export function encrypt(txt, publicKey) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey); // 设置公钥
  return encryptor.encrypt(txt); // 对数据进行加密
}
